import React from "react";
import { Container, CircularProgress, Typography, Box } from "@mui/material";

const Loader = ({ message }) => {
  return (
    <Container>
      <Box className="flex flex-col items-center justify-center py-10 space-y-4">
        <CircularProgress aria-label="Loading indicator" />
        {message && (
          <Typography variant="body1" className="text-gray-600 text-center">
            {message}
          </Typography>
        )}
      </Box>
    </Container>
  );
};

export default Loader;
